import { Component } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-enterprise';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';                             
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import * as moment from 'moment';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Component({
  selector: 'app-notify-users-email-list',
  templateUrl: './notify-users-email-list.component.html',
  styleUrl: './notify-users-email-list.component.css',
   standalone: false
})
export class NotifyUsersEmailListComponent {
  orgId: any;
  orgUpdateForm: UntypedFormGroup;
  additionalMessageResponse: any;
  redirectedFromBol: any;
  profileName: any;
  currentMessage: any;
  messageArray = [];
  messages: any;
  audiTrailData: any;
  emailRecipientList: any;
  columnDefs: (ColDef | ColGroupDef)[];
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private formBuilder: UntypedFormBuilder, 
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private route: ActivatedRoute,

    private bsModalRef: BsModalRef,
    public options: ModalOptions,
    ) {
      this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
    this.orgUpdateForm = this.formBuilder.group({
      newMessage: new UntypedFormControl('')
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.audiTrailData,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
   onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }
    
  
  ngOnInit() {

    this.emailRecipientList = this.options.initialState;
    this.rowData = this.emailRecipientList.emailRecipientList;
    this.updateColumnDefs();
   // this.profileName = this.audiTrailData.profile;  
    this.tmssLoader.hide(); 
  }


 updateColumnDefs() {
  this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
}

getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
  return [
    <ColDef>
      {
        resizable: true,
        wrapText: true,
        width: 150,
        headerName: 'Business Type',
        field: 'businessType',
        filter: 'agTextColumnFilter', 
        sortable: true
       
      },
      {
        resizable: true,
        wrapText: true,
        width: 100,
        headerName: 'User Type',
        field: 'userType',        
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        resizable: true,
        wrapText: true,
        width: 160,
        headerName: 'User Sub Type',
        field: 'userSubType',
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Recipient Email',
        field: 'recipientEmail',
        filter: 'agTextColumnFilter', 
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Recipient Organization',
        field: 'recipientOrganization',
        filter: 'agTextColumnFilter', 
        sortable: true
      }
    ];
}

  loadMessageHistory(existingMessages) {
    /* for(let i = 0; i<existingMessages.length(); i++) {
      this.messageHistoryArray[i] = existingMessages[i].message;
    } */
  }

  /**
   * @description cancel message entered
   */
  cancelMessage() {
    // this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();

  }

}
